import { Component } from '@angular/core';

@Component({
  selector: 'empathy-rank-sort',
  templateUrl: './rank-sort-description.component.html',
  styleUrls: ['./rank-sort-description.component.scss']
})
export class RankSortDescriptionComponent {}
